import { RelatedProductType } from '@shared/product/related-products/domain/models/related-products.models';
import { GridType } from '@shared/ui/models/grid-type.model';

export interface UniversalAnalyticsState {
    pageviewSent: boolean;
    chat: {
        firstMessagePendingToBeSent: boolean;
    };
}

export interface Ga4GeneralAnalyticsState {
    pageviewSent: boolean;
    lastBundleReference?: string;
}

export interface AnalyticsState {
    error: any;
    events: any[];
    fromLastSizesType: string;
    ga4: Ga4GeneralAnalyticsState;
    referredSent: boolean;
    related: AnalyticsRelatedState;
    searchOrigin: any;
    typePhoto: number;
    universal: UniversalAnalyticsState;
}

export interface AnalyticsRelatedState {
    type: string;
}

export const analyticsInitialState: AnalyticsState = {
    events: [],
    universal: {
        pageviewSent: false,
        chat: {
            firstMessagePendingToBeSent: false,
        },
    },
    ga4: {
        pageviewSent: false,
    },
    error: {},
    related: {
        type: null,
    },
    fromLastSizesType: null,
    searchOrigin: null,
    typePhoto: null,
    referredSent: false,
};

export interface ProductEventExtraData {
    carouselIndex?: number;
    carouselLength?: number;
    gridType?: GridType;
    imBundleReference?: string;
    isMobile?: boolean;
    mediaPath?: string;
    pageTitle?: string;
    parentType?: RelatedProductType;
    position?: number;
    productType?: string;
    quantity?: number;
    type?: string;
    typePhoto?: number;
}

export enum SearchRequestMethodName {
    search = 'search',
    query = 'query',
}

export interface SearchPerformance {
    methodName: SearchRequestMethodName;
    responseCode: number;
    resultsNumber: string;
    searchTerm: string;
}
